<div class="relative">
  <button
    type="button"
    (click)="click();"
    class="button {{classes}}"
    [ngClass]="{
      'disabled': disabled,
      'splitButton': isHalf,
      'shortButton': isShort
    }"
    [disabled]="disabled"
    [matTooltip]="tooltip"
    [id]="id"
    [routerLink]="routerLink"
    [queryParams]="queryParams"
  >{{text}}</button>
  @if(isHalf) {
    <i class="material-icons splitArrow" (click)="click();" aria-hidden="true">keyboard_arrow_down</i>
  }
</div>
